import { createSlice } from "@reduxjs/toolkit";
import { MESSAGE_SLICE_NAME } from "./actions";
import { sendMessageReducer } from "./reducers";

export interface MessageState {
  isLoading: boolean;
}

const initialState: MessageState = {
  isLoading: false,
};

export const { reducer: message } = createSlice({
  name: MESSAGE_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    sendMessageReducer(builder);
  },
});
